import ChartBaseController from "./chart_base_controller";
import { handleChartError, withErrorHandling } from "./chart_error_handler";

export default class ChartBarBenchmarkController extends withErrorHandling(ChartBaseController) {
  // Class property to store campaign and benchmark data
  campaignData = null;

  static values = {
    ...ChartBaseController.values,
    xKey: String,
    yKey: String,
    yName: String,
    series: Array,
    data: Array,
  }

  formatData(data) {
    // Handle potential errors
    const result = handleChartError(data, this.chartTarget);
    if (result.hasError) {
      this.hasError = true;
      return result.formattedData || [];
    }

    // Reset error flag
    this.hasError = false;

    // Store the original JSON response for series formatting
    this.campaignData = data;

    // Format data for charting
    const allRatings = new Set();
    data.forEach(campaign => {
      Object.keys(campaign.ratings).forEach(rating => {
        allRatings.add(rating);
      });
    });

    const sortedRatings = Array.from(allRatings).sort((a, b) => a - b);

    return sortedRatings.map(rating => {
      const ratingObj = { rating };
      data.forEach(campaign => {
        ratingObj[campaign.form_campaign_id] = campaign.ratings[rating] || 0;
      });
      return ratingObj;
    });
  }

  getChartOptions(data) {
    const options = super.getChartOptions(data);

    // Only format series if valid campaign data exists
    if (this.campaignData && !this.campaignData.error && Array.isArray(this.campaignData)) {
      options.series = this.formatSeries(this.campaignData);
    }

    return options;
  }


  formatSeries(campaigns) {
    return campaigns.map((campaign) => ({
      type: 'bar',
      label: {
        formatter: function(params) {
          return params.value.toString();
        },
        enabled: true,
        fontSize: 12,
        placement: 'outside-end',
        color: '#333333',
      },
      xKey: this.xKeyValue,
      yKey: campaign.form_campaign_id,
      yName: campaign.form_campaign_name,
      cornerRadius: 2,
      fillOpacity: 1,
    }));
  }
}
